export default __webpack_public_path__ + "static/media/TEXTURA_06.92d8d3b4.png";